import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import FieldImageView from './View';
import fieldImageBlockSchema from './schema';
import { useSelector } from 'react-redux';

export const FieldImageEdit = (props) => {
  const {
    block,
    blocksErrors,
    blocksConfig,
    onChangeBlock,
    data,
    selected,
    intl,
  } = props;

  const schema = blocksConfig[data['@type']].blockSchema({
    ...props,
    intl,
  });
  const dataAdapter = blocksConfig[data['@type']].dataAdapter;

  const request = useSelector((state) => state.content.subrequests[block]);
  const content = request?.data;
  // let schema = fieldImageBlockSchema({ data, intl });

  return (
    <>
      <FieldImageView
        {...props}
        path={getBaseUrl(props.pathname)}
        mode="edit"
      />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value, item) => {
            dataAdapter({
              block,
              data,
              id,
              onChangeBlock,
              value,
              content,
              item,
            });
          }}
          formData={data}
          block={block}
          errors={blocksErrors}
          onChangeBlock={onChangeBlock}
          blocksConfig={blocksConfig}
        />
      </SidebarPortal>
    </>
  );
};

export default FieldImageEdit;
